import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { AdvanceWrite, SettlementAdvance } from '../types'

export function useCreateAdvance() {
  return useSettlementMutation<
    { id: string; body: AdvanceWrite },
    SettlementAdvance
  >({
    toastKey: 'settlementAdvanceCreated',
    request: async ({ id, body }) =>
      (
        await apiClient.post<SettlementAdvance>(
          `${settlementsUrl}/${id}/advances`,
          body
        )
      ).data
  })
}

export function useUpdateAdvance() {
  return useSettlementMutation<
    { id: string; advanceId: string; body: Partial<AdvanceWrite> },
    SettlementAdvance
  >({
    toastKey: 'settlementAdvanceUpdated',
    request: async ({ id, advanceId, body }) =>
      (
        await apiClient.patch<SettlementAdvance>(
          `${settlementsUrl}/${id}/advances/${advanceId}`,
          body
        )
      ).data
  })
}

export function useDeleteAdvance() {
  return useSettlementMutation<{ id: string; advanceId: string }, void>({
    toastKey: 'settlementAdvanceDeleted',
    request: async ({ id, advanceId }) => {
      await apiClient.delete(`${settlementsUrl}/${id}/advances/${advanceId}`)
    }
  })
}
